import { supabase } from '@/lib/supabase/client';
import type { QueryClient } from '@tanstack/react-query';
import type { RealtimeChannel } from '@supabase/supabase-js';

// Opens a Postgres CDC channel scoped to one document version and invalidates
// the ['annotations', versionId] TanStack Query cache on any row change.
// Returns the subscribed channel so the caller can unsubscribe later.
export function subscribeAnnotations(
  versionId: string,
  queryClient: QueryClient,
): RealtimeChannel {
  return supabase
    .channel(`annotations:${versionId}`)
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'annotations',
        filter: `document_version_id=eq.${versionId}`,
      },
      () => queryClient.invalidateQueries({ queryKey: ['annotations', versionId] }),
    )
    .subscribe();
}
